import Client from './axiosClient'
const resource = '/bank';
const resourceInit = '/bank_initialize';

export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  get() {
    return Client.get(`${resource}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

};



// WEBPACK FOOTER //
// ./src/repositories/bankRepository.js